import React, { Component } from "react";
import PropTypes from "prop-types";
import {
  Row,
  Col,
  Button,
  FormGroup,
  FormControl,
  ControlLabel,
  Alert,
  Tooltip,
  Modal,
  Tabs,
  Tab,
  Checkbox,
  Image
} from "react-bootstrap";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { bindActionCreators, compose } from "redux";
import { createBrowserHistory } from "history";
import { NewBreadcrumb as BreadcrumbComponent } from "../../../components";
import "../../../style/subAdmin/SubAdmin.scss";
import { Notification } from "../../../components/notifications";
import isEmpty from "lodash.isempty";
import { countryCityActions } from "../../../redux/actions/countryCityActions";
import { merchantActions } from "../../../redux/actions/merchantActions";
import { salesPersonActions } from "../../../redux/actions/salesPersonActions";
import { categoriesActions } from "../../../redux/actions/categories";
import DatePicker from "react-date-picker";
import moment from "moment";
import "react-datepicker/dist/react-datepicker.css";
import { alertsActions } from "../../../redux/actions/alertsActions";
import loader from "../../../style/loader/loader.scss";
import auth from "../../../services/auth";
import NumberFormat from "react-number-format";
import ReactAutocomplete from "react-autocomplete";
import {aclUtil} from "../../util"

let merchantID = "",
xCoordinate = {},
yCoordinate = {};
const history = createBrowserHistory();
const HorizontalLine = ({}) => <hr />;

const propTypes = {
  countries: PropTypes.array.isRequired
};

const ContactInformationArr = [{'ciName' : 'Secondary', 'ciKey' : 'secondary'}, {'ciName' : 'Tertiary', 'ciKey' : 'tertiary'}];
let cityItems = [], taxtype="",
  isLoading = "false", PhylocationTax=[], phyidxx="",
  userinfo = "";
let runOnce = false;
class AddMerchant extends Component {
  static contextTypes = {
    router: PropTypes.object
  }
  constructor(props) {
    super(props);

    this.state = {
      menuKey: 'ADD_MERCHANT',
      path: ["Home", "Manage Merchants", "Add New"],
      links:["home", "merchantList", "addMerchant"],
      startDate: moment(),
      ContactInformation:[],
      countryData: [],
      statesName: [],
      citiesName: [],
      merchantID: "",
      userID: "",
      merchantName: "",
      merchantNameError: "",
      listMerchantDirectory: "0",
      legalName: "",
      legalNameError: "",
      websiteUrl: "",
      websiteUrlError: "",
      facebookPage: "",
      facebookPageError: "",
      twitterPage: "",
      twitterPageError: "",
      catIDError: "",
      metaKeywords: "",
      metaKeywordsError: "",
      metaDesc: "",
      metaDescError: "",
      bankInfo: 0,
      bankInfoError: "",
      bankName: "",
      bankNameError: "",
      bankAccountNo: "",
      bankAccountNoError: "",
      bankRoutingNum: "",
      bankRoutingNumError: "",
      vatExempt: 1,
      vatExemptError: "",
      paymentTerms: "single-step",
      paymentTermsError: "",
      defaultTaxPerc: "",
      defaultTaxPercError: "",
      secondaryContactFirstName: "",
      secondaryContactFirstNameError: "",
      secondaryContactLastName: "",
      secondaryContactLastNameError: "",
      secondaryContactPhone: "",
      secondaryContactPhoneError: "",
      secondaryContactEmail: "",
      secondaryContactEmailError: "",
      tertiaryContactFirstName: "",
      tertiaryContactFirstNameError: "",
      tertiaryContactLastName: "",
      tertiaryContactLastNameError: "",
      tertiaryContactPhone: "",
      tertiaryContactPhoneError: "",
      tertiaryContactEmail: "",
      tertiaryContactEmailError: "",
      id: "",
      userName: "",
      userNameError: "",
      email: "",
      emailError: "",
      firstName: "",
      firstNameError: "",
      lastName: "",
      lastNameError: "",
      phone: "",
      phoneError: "",
      address1: "",
      address1Error: "",
      address2: "",
      address2Error: "",
      cityID: "",
      cityIDError: "",
      city: "",
      Citytitle: "",
      cityError: "",
      state: "",
      stateError: "",
      countryValue: "",
      countryError: "",
      zipcode: "",
      zipcodeError: "",
      dob: "",
      dobError: "",
      status: "Active",
      alertMessage: "",
      msgType: "success",
      phylocidx: "0",
      statesopt: [],
      statesoption: [],
      cityoptions: [],
      physicalLocations: [],
      counter: 0,
      changestateProps: false,
      catList: [],
      // merchantType: [],
      showBankInfo: false,
      statesList: [],
      citiesList: [],
      cityList: [],
      stateList: [],
      FiltercitiesList: [],
      changeCountry: false,
      changeState: false,
      changeCity: false,
      updatePhysicalLocCity: [],
      updatingState: false,
      updateCity: [],
      updateState: [],
      show: false,
      merchantclass: "",
      disabled: false,
      salespersonlist: [],
      salesManagerID: "",
      defaultTaxError:"",
      merchantdefaultTax:false,
      locdefaultTax:false,
      logomerchantId:'',
      showLogoPopup:false,
      src:'',
      merchant_logo:'',
      FilterStateList:[],
      addState: '',
      addStateError: '',
      addCity: '',
      addCityError: '',
    };

    this.handlePhysicalLocationsSubmit = this.handlePhysicalLocationsSubmit.bind(
      this
    );
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.validate = this.validate.bind(this);
    this.handleUpdateDates = this.handleUpdateDates.bind(this);
    this.handleDismiss = this.handleDismiss.bind(this);
    this.handleShow = this.handleShow.bind(this);
    this.Clear = this.Clear.bind(this);
    this.handleAddLogo =this.handleAddLogo.bind(this);
    this.LogoClosePopup = this.LogoClosePopup.bind(this);
    this.handleLogoData = this.handleLogoData.bind(this);
    this.UploadLogo = this.UploadLogo.bind(this);
    // this.onChangeState = this.onChangeState.bind(this);
    this.handleCheck = this.handleCheck.bind(this);
    // this.onChangeCity = this.onChangeCity.bind(this);
    this.onSelectedState = this.onSelectedState.bind(this);
    this.onSelectedCity = this.onSelectedCity.bind(this)
  }

  onChangeStartDate = date => { this.setState({ dob: date})};

  handleBlurLatitude = idx => evt => {
    let phyLoc = this.state.physicalLocations;
    phyLoc[idx].locLatitudeError = "";
    this.setState({ physicalLocations: phyLoc });
  };
  handleBlurLongitude = idx => evt => {
    let phyLoc = this.state.physicalLocations;
    phyLoc[idx].locLongitudeError = "";
    this.setState({ physicalLocations: phyLoc });
  };

  handleUpdateDates(date) {
    this.setState({
      startDate: date
    });
  }

  handleCheck(e) {
    if (e.target.checked == true) {
      this.setState({ [e.target.name]: 1 });
    } else {
      this.setState({ [e.target.name]: 0 });
    }
    this.setState({ disabled: false });
  }

  //Physical Location Address 1 onchange
  handleLocAddress1Change = idx => evt => {
    this.setState({ disabled: false });
    const newPhysicalLocations = this.state.physicalLocations.map(
      (phylocation, pidx) => {
        if (idx !== pidx) return phylocation;
        return { ...phylocation, locAddress1: evt.target.value };
      }
    );

    this.setState({ physicalLocations: newPhysicalLocations });
    let phyLoc = this.state.physicalLocations;
    if (phyLoc[idx].locAddress1Error !== "") {
      phyLoc[idx].locAddress1Error = "";
      this.setState({ physicalLocations: phyLoc });
    }
  };

  handleDismiss() {
    this.setState({ show: false });
  }

  handleShow() {
    this.setState({ show: true });
  }

  getValidationState() {
    if (this.state.phone) {
      const length = this.state.phone.length;
      if (length !== 0) {
        let mobilepattern = new RegExp(/^\d{3}-\d{3}-\d{4}$/i);
        if (!mobilepattern.test(this.state.phone)) {
          return "error";
        }
      }
    }

    return null;
  }

  getValidationLocPhone(idx) {
    const locPhone =
      this.state.physicalLocations[idx] &&
      this.state.physicalLocations[idx].locPhone;
    if (locPhone) {
      const length = locPhone.length;
      if (length !== 0) {
        let mobilepattern = new RegExp(/^\d{3}-\d{3}-\d{4}$/i);
        if (!mobilepattern.test(locPhone)) {
          return "error";
        }
      }
    }

    return null;
  }

  getValidationPhysicalLocationState(idx) {
    let locPhone = [];
    let physicalLocations = this.state.physicalLocations;
    physicalLocations.map(phylocation => locPhone.push(phylocation.locPhone));
    let phyLoc = this.state.physicalLocations;
    if (phyLoc[idx].locPhone !== null && phyLoc[idx].locPhone !== "") {
      let mobilepattern = new RegExp(/^\d{3}-\d{3}-\d{4}$/i);
      if (!mobilepattern.test(locPhone)) {
        return "error";
      } else {
        return "";
      }
    }
    return null;
  }

  getValidationPhysicalLocationAddress1State(idx) {
    let locAddress1 = [];
    let physicalLocations = this.state.physicalLocations;
    physicalLocations.map(phylocation =>
      locAddress1.push(phylocation.locAddress1)
    );
    let phyLoc = this.state.physicalLocations;
    if (phyLoc[idx].locAddress1 == null && phyLoc[idx].locAddress1 == "") {
      return "error";
    } else {
      return "";
    }
    //return null
  }

  getValidationPhysicalLocationCountryState(idx) {
    let locCountry = [];
    let physicalLocations = this.state.physicalLocations;
    physicalLocations.map(phylocation =>
      locCountry.push(phylocation.locCountry)
    );
    let phyLoc = this.state.physicalLocations;
    if (phyLoc[idx].locCountry == null && phyLoc[idx].locCountry == "") {
      return "error";
    } else {
      return "";
    }
  }

  getValidationPhysicalLocationStatesState(idx) {
    let locState = [];
    let physicalLocations = this.state.physicalLocations;
    physicalLocations.map(phylocation => locState.push(phylocation.locState));
    let phyLoc = this.state.physicalLocations;
    if (phyLoc[idx].locState == null && phyLoc[idx].locState == "") {
      return "error";
    } else {
      return "";
    }
  }

  getValidationPhysicalLocationCityState(idx) {
    let locCity = [];
    let physicalLocations = this.state.physicalLocations;
    physicalLocations.map(phylocation => locCity.push(phylocation.locCity));
    let phyLoc = this.state.physicalLocations;
    if (phyLoc[idx].locCity == null && phyLoc[idx].locCity == "") {
      return "error";
    } else {
      return "";
    }
  }

  getValidationPhysicalLocationTaxState(idx) {
    let taxPerc = [];
    let physicalLocations = this.state.physicalLocations;
    physicalLocations.map(phylocation => taxPerc.push(phylocation.taxPerc));
    let phyLoc = this.state.physicalLocations;
    if (phyLoc[idx].taxPerc == null && phyLoc[idx].taxPerc == "") {
      return "error";
    } else {
      return "";
    }
  }

  getValidationPhysicalLocationLatitudeState(idx) {
    let locLatitude = [];
    let physicalLocations = this.state.physicalLocations;
    physicalLocations.map(phylocation =>
      locLatitude.push(phylocation.locLatitude)
    );
    let phyLoc = this.state.physicalLocations;
    if (phyLoc[idx].locLatitude == null && phyLoc[idx].locLatitude == "") {
      return "error";
    } else {
      return "";
    }
  }

  getValidationPhysicalLocationLongitudeState(idx) {
    let locLongitude = [];
    let physicalLocations = this.state.physicalLocations;
    physicalLocations.map(phylocation =>
      locLongitude.push(phylocation.locLongitude)
    );
    let phyLoc = this.state.physicalLocations;
    if (phyLoc[idx].locLongitude == null && phyLoc[idx].locLongitude == "") {
      return "error";
    } else {
      return "";
    }
    return null;
  }

  getValidationsecondaryContactState() {
    if (this.state.secondaryContactPhone) {
      const length = this.state.secondaryContactPhone.length;
      if (length !== 0) {
        let mobilepattern = new RegExp(/^\d{3}-\d{3}-\d{4}$/i);
        if (!mobilepattern.test(this.state.secondaryContactPhone)) {
          return "error";
        }
      }
    }

    return null;
  }

  getValidationTertiaryContactState() {
    if (this.state.tertiaryContactPhone) {
      const length = this.state.tertiaryContactPhone.length;
      if (length !== 0) {
        let mobilepattern = new RegExp(/^\d{3}-\d{3}-\d{4}$/i);
        if (!mobilepattern.test(this.state.tertiaryContactPhone)) {
          return "error";
        }
      }
    }

    return null;
  }

  //Physical Location Address 2 onchange
  handleLocAddress2Change = idx => evt => {
    this.setState({ disabled: false });
    const newPhysicalLocations = this.state.physicalLocations.map(
      (phylocation, pidx) => {
        if (idx !== pidx) return phylocation;
        return { ...phylocation, locAddress2: evt.target.value };
      }
    );

    this.setState({ physicalLocations: newPhysicalLocations });
    let phyLoc = this.state.physicalLocations;
    if (phyLoc[idx].locAddress2Error !== "") {
      phyLoc[idx].locAddress2Error = "";
      this.setState({ physicalLocations: phyLoc });
    }
  };

  handleLocationName = idx => evt => {
    this.setState({ disabled: false });
    const newPhysicalLocations = this.state.physicalLocations.map(
      (phylocation, pidx) => {
        if (idx !== pidx) return phylocation;
        return { ...phylocation, LocationName: evt.target.value };
      }
    );
    this.setState({ physicalLocations: newPhysicalLocations });
    let phyLoc = this.state.physicalLocations;
    if (phyLoc[idx].LocationNameError !== "") {
      phyLoc[idx].LocationNameError = "";
      this.setState({ physicalLocations: phyLoc });
    }
  };

  //Physical Location Phone onchange
  handlelocZipCodeChange = idx => evt => {
    this.setState({ disabled: false });
    const newPhysicalLocations = this.state.physicalLocations.map(
      (phylocation, pidx) => {
        if (idx !== pidx) return phylocation;
        return { ...phylocation, locZipCode: evt.target.value };
      }
    );

    this.setState({ physicalLocations: newPhysicalLocations });
    let phyLoc = this.state.physicalLocations;
    if (phyLoc[idx].locZipCodeError !== "") {
      phyLoc[idx].locZipCodeError = "";
      this.setState({ physicalLocations: phyLoc });
    }
  };

  handlelocPhoneChange = idx => evt => {
    this.setState({ disabled: false });
    const newPhysicalLocations = this.state.physicalLocations.map(
      (phylocation, pidx) => {
        if (idx !== pidx) return phylocation;
        return { ...phylocation, locPhone: evt.target.value };
      }
    );

    this.setState({ physicalLocations: newPhysicalLocations });
    let phyLoc = this.state.physicalLocations;
    if (phyLoc[idx].locPhoneError !== "") {
      phyLoc[idx].locPhoneError = "";
      this.setState({ physicalLocations: phyLoc });
    }
  };

  //Physical Location Tax Perventage onchange
  handletaxPercChange = idx => evt => {
    this.setState({ disabled: false });
    const newPhysicalLocations = this.state.physicalLocations.map(
      (phylocation, pidx) => {
        if (idx !== pidx) return phylocation;
        return { ...phylocation, taxPerc: evt.target.value };
      }
    );

    this.setState({ physicalLocations: newPhysicalLocations });
    let phyLoc = this.state.physicalLocations;
    if (phyLoc[idx].taxPercError !== "") {
      phyLoc[idx].taxPercError = "";
      this.setState({ physicalLocations: phyLoc });
    }
  };

  //Physical Location Latitude onchange
  handleLocLatitudeChange = idx => evt => {
    this.setState({ disabled: false });
    const newPhysicalLocations = this.state.physicalLocations.map(
      (phylocation, pidx) => {
        if (idx !== pidx) return phylocation;
        return { ...phylocation, locLatitude: evt.target.value };
      }
    );

    this.setState({ physicalLocations: newPhysicalLocations });
    let phyLoc = this.state.physicalLocations;
    if (phyLoc[idx].locLatitudeError !== "") {
      phyLoc[idx].locLatitudeError = "";
      this.setState({ physicalLocations: phyLoc });
    }
  };

  //Physical Location Longitude onchange
  handleLocLongitudeChange = idx => evt => {
    this.setState({ disabled: false });
    const newPhysicalLocations = this.state.physicalLocations.map(
      (phylocation, pidx) => {
        if (idx !== pidx) return phylocation;
        return { ...phylocation, locLongitude: evt.target.value };
      }
    );

    this.setState({ physicalLocations: newPhysicalLocations });
    let phyLoc = this.state.physicalLocations;
    if (phyLoc[idx].locLongitudeError !== "") {
      phyLoc[idx].locLongitudeError = "";
      this.setState({ physicalLocations: phyLoc });
    }
  };

  onWebsiteUrlBlur = field => e => {
    e.preventDefault();
    if (field.length > 0) {
      let regexp =  /^((https?|ftp|smtp):\/\/)+(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:\/\S*)?$/;
      if (
        !regexp.test(
          field
        )
      ) {
        this.setState({ websiteUrlError: "Invalid Format" });
      } else {
        this.setState({ websiteUrlError: "" });
      }
    }
  };

  //Add Contact Information
  handleAddContactLocation = idx => {
    let tmpContactArr = this.state.ContactInformation;
    tmpContactArr.push(tmpContactArr.length);
    this.setState({ ContactInformation: tmpContactArr });
  }
  //Add Physical Location
  handleAddPhysicalLocation = idx => {
    this.setState({ disabled: false });
    let stateArray = this.state.statesName;
    stateArray.push([]);
    this.setState({ statesName: stateArray });
    let cityArray = this.state.citiesName;
    cityArray.push([]);
    this.setState({ citiesName: cityArray });
    this.setState({
      physicalLocations: this.state.physicalLocations.concat([
        {
          locAddress1: "",
          locAddress1Error: "",
          locAddress2: "",
          locAddress2Error: "",
          locZipCode:"",
          locZipCodeError: "",
          locPhone: "",
          locPhoneError: "",
          taxPerc: "",
          taxPercError: "",
          locLatitude: "",
          locLatitudeError: "",
          locLongitude: "",
          locLongitudeError: "",
          loccityID: "",
          loccityIDError: "",
          locCity: "",
          locCityError: "",
          locState: "",
          locStateError: "",
          locCountry: "",
          locCountryError: "",
          loccityID: "",
          LocationID: "",
          LocationIDError: "",
          LocationName:"",
          LocationNameError:"",
        }
      ])
    });
  };

  //Remove Physical Location
  handleRemovePhysicalLocation = idx => () => {
    this.setState({ disabled: false });
    if (
      this.state.merchantID !== "" &&
      typeof this.state.physicalLocations[idx].locID != "undefined"
    ) {
      const locIDParam = this.state.physicalLocations[idx].locID;
      const merchantIDParams = this.state.merchantID;
      this.props.dispatch(
        merchantActions.delete_merchant_location(merchantIDParams, locIDParam)
      );
    }
    let statesNameConst;
    statesNameConst = this.state.statesName;
    statesNameConst.splice(idx);
    this.setState({
      statesName: statesNameConst,
      physicalLocations: this.state.physicalLocations.filter(
        (p, pidx) => idx !== pidx
      )
    });
  };

  // Handle input onchange
  handleChange(e) {
    if (`${e.target.name}Error` !== "") {
      this.setState({ [`${e.target.name}Error`]: "" });
    }
    this.setState({ [e.target.name]: e.target.value });
    this.setState({ disabled: false });
   
  }

  handleAddLogo(e) { 
    let data = e.target.attributes.getNamedItem('data-key').value;
    this.setState({
      logomerchantId: data,
      showLogoPopup: true,
    });
  }

  LogoClosePopup(e) { 
    this.setState({
      logomerchantId: '',
      showLogoPopup: false,
    });
  }

  UploadLogo(e) {
    const formData = new FormData(); 
    this.setState({ 
      isLoading: true
    });
    var reader = new FileReader();
    var url = reader.readAsDataURL(this.state.src);
    reader.onloadend = function (e) {
      this.setState({merchant_logo: reader.result});
    }.bind(this); 
    formData.append("merchantID", this.state.merchantID);
    formData.append("file", this.state.src); 
    this.props.dispatch(merchantActions.UploadLogo(formData));
  }

  handleLogoData(e) {
    let files = e.target.files;
    this.setState({src: files[0]}); 
  }

  validate = () => {
    xCoordinate = {}
    yCoordinate = {}
    let isError = false;
    const errors = {};
    if (this.state.merchantName.length === 0) {
      isError = true;
      this.setState({ merchantNameError: "red" });
      if(xCoordinate.key !== 'formBasicMerchantNameText'){
        let x = window.scrollX + document.querySelector('#formBasicMerchantNameText').getBoundingClientRect().left
        let y = window.scrollY + document.querySelector('#formBasicMerchantNameText').getBoundingClientRect().top - 89
        xCoordinate['formBasicMerchantNameText'] = x;
        yCoordinate['formBasicMerchantNameText'] = y;
      }
    }
    if (this.state.legalName.length === 0) {
      isError = true;
      this.setState({ legalNameError: "red" });
      if(xCoordinate.key !== 'formBasicLegalNameText'){
        let x = window.scrollX + document.querySelector('#formBasicLegalNameText').getBoundingClientRect().left
        let y = window.scrollY + document.querySelector('#formBasicLegalNameText').getBoundingClientRect().top - 89
        xCoordinate['formBasicLegalNameText'] = x;
        yCoordinate['formBasicLegalNameText'] = y;
      }
    }
    // if (this.state.userName.length === 0) {
    //   isError = true;
    //   this.setState({ userNameError: "red" });
    // }
    if (this.state.email.length === 0) {
      isError = true;
      this.setState({ emailError: "red" });
      if(xCoordinate.key !== 'formBasicEmailText'){
        let x = window.scrollX + document.querySelector('#formBasicEmailText').getBoundingClientRect().left
        let y = window.scrollY + document.querySelector('#formBasicEmailText').getBoundingClientRect().top - 89
        xCoordinate['formBasicEmailText'] = x;
        yCoordinate['formBasicEmailText'] = y;
      }
    } else if (this.state.email) {
      if (this.getValidationEmailState()) {
        isError = true;
        if(xCoordinate.key !== 'formBasicEmailText'){
        let x = window.scrollX + document.querySelector('#formBasicEmailText').getBoundingClientRect().left
        let y = window.scrollY + document.querySelector('#formBasicEmailText').getBoundingClientRect().top - 89
        xCoordinate['formBasicEmailText'] = x;
        yCoordinate['formBasicEmailText'] = y;
      }
      }
    }
    if (this.state.addState.length === 0) {
      isError = true;
      this.setState({ addStateError: "red" });
      if(xCoordinate.key !== 'formBasicAddStateText'){
        let x = window.scrollX + document.querySelector('#formBasicAddStateText').getBoundingClientRect().left
        let y = window.scrollY + document.querySelector('#formBasicAddStateText').getBoundingClientRect().top - 89
        xCoordinate['formBasicAddStateText'] = x;
        yCoordinate['formBasicAddStateText'] = y;
      }
    }
    if (this.state.addCity.length === 0) {
      isError = true;
      this.setState({ addCityError: "red" });
      if(xCoordinate.key !== 'formBasicAddCityText'){
        let x = window.scrollX + document.querySelector('#formBasicAddCityText').getBoundingClientRect().left
        let y = window.scrollY + document.querySelector('#formBasicAddCityText').getBoundingClientRect().top - 89
        xCoordinate['formBasicAddCityText'] = x;
        yCoordinate['formBasicAddCityText'] = y;
      }
    }

    if (this.state.cityID.length === 0) {
      isError = true;
      this.setState({ cityIDError: "red" });
      if(xCoordinate.key !== 'primaryContactInfo'){
        let x = window.scrollX + document.querySelector('#formBasicCityIDText').getBoundingClientRect().left
        let y = window.scrollY + document.querySelector('#formBasicCityIDText').getBoundingClientRect().top - 89
        xCoordinate['formBasicCityIDText'] = x;
        yCoordinate['formBasicCityIDText'] = y;
      }
    }

    if (this.state.state.length === 0) {
      isError = true;
      this.setState({ stateError: "red" });
      if(xCoordinate.key !== 'primaryContactInfoState'){
        let x = window.scrollX + document.querySelector('#primaryContactInfoState').getBoundingClientRect().left
        let y = window.scrollY + document.querySelector('#primaryContactInfoState').getBoundingClientRect().top - 89
        xCoordinate['primaryContactInfoState'] = x;
        yCoordinate['primaryContactInfoState'] = y;
      }
    }
    if (this.state.countryValue.length === 0) {
      isError = true;
      this.setState({ countryError: "red" });
      if(xCoordinate.key !== 'primaryContactInfoCountry'){
        let x = window.scrollX + document.querySelector('#primaryContactInfoCountry').getBoundingClientRect().left
        let y = window.scrollY + document.querySelector('#primaryContactInfoCountry').getBoundingClientRect().top - 89
        xCoordinate['primaryContactInfoCountry'] = x;
        yCoordinate['primaryContactInfoCountry'] = y;
      }
    }

    if (this.state.secondaryContactEmail) {
      if (this.getValidationSecondryEmailState()) {
        isError = true;
      }
    }

    if (this.state.tertiaryContactEmail) {
      if (this.getValidationTertiaryEmailState()) {
        isError = true;
      }
    }

    if (this.state.phone) {
      if (this.getValidationState()) {
        isError = true;
      }
    }

    if (this.state.secondaryContactPhone) {
      if (this.getValidationsecondaryContactState()) {
        isError = true;
      }
    }

    if (this.state.tertiaryContactPhone) {
      if (this.getValidationTertiaryContactState()) {
        isError = true;
      }
    }

    if (this.state.phone) {
      if (this.getValidationState()) {
        isError = true;
      }
    }
    return isError;
  };

  getValidationEmailState() {
    if (this.state.email) {
      const length = this.state.email.length;
      if (length !== 0) {
        let emailpattern = new RegExp(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i);
        if (!emailpattern.test(this.state.email) || this.state.email.length >= 50) {
          return "error";
        }
      }
    }

    return null;
  }
  getValidationWebsiteUrlState() {
    if (this.state.websiteUrl) {
      const length = this.state.websiteUrl.length;
      //!/^((https?|ftp|smtp):\/\/)+(www.)+[a-z0-9]+(\.[a-z]{2,}){1,3}(#?\/?[a-zA-Z0-9#]+)*\/?(\?[a-zA-Z0-9-_]+=[a-zA-Z0-9-%]+&?)?$/gi
      if (length !== 0) {
        let regexp =  /^((https?|ftp|smtp):\/\/)+(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:\/\S*)?$/;
        if (
          !regexp.test(
            this.state.websiteUrl
          )
        ) {
          return "error";
        }
      }
    }

    return null;
  }
  getValidationLatitude(idx) {
    let phyLoc = this.state.physicalLocations;
    const latitude = phyLoc[idx].locLatitude;
    if (latitude !== "" && latitude !== null) {
      if (
        !/^-?([1]?[1-7][1-9]|[1]?[1-8][0]|[1-9]?[0-9])\.{1}\d{1,6}$/.test(
          latitude
        )
      ) {
        return "error";
      }
    }
    return null;
  }
  getValidationLongitude(idx) {
    let phyLoc = this.state.physicalLocations;
    const longitude = phyLoc[idx].locLongitude;
    if (longitude !== "" && longitude !== null) {
      if (
        !/^-?([1]?[1-7][1-9]|[1]?[1-8][0]|[1-9]?[0-9])\.{1}\d{1,6}$/.test(
          longitude
        )
      ) {
        return "error";
      }
    }
    return null;
  }

  getValidationSecondryEmailState() {
    if (this.state.secondaryContactEmail) {
      const length = this.state.secondaryContactEmail.length;
      if (length !== 0) {
        let emailpattern2 = new RegExp(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i);
        if (!emailpattern2.test(this.state.secondaryContactEmail)) {
          return "error";
        }
      }
    }

    return null;
  }

  getValidationTertiaryEmailState() {
    if (this.state.tertiaryContactEmail) {
      let emailpattern2 = new RegExp(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i);
      if (!emailpattern2.test(this.state.tertiaryContactEmail)) {
        return "error";
      }
    }

    return null;
  }

  componentWillUnmount() {
    this.props.dispatch(alertsActions.clearAlerts());
  }

  handleSubmit(e) {
    e.preventDefault();
    const err = this.validate();
    this.handleDismiss();
    if (!err) {
      this.setState({ disabled: true , ContactInformation: []});
      if (this.state.merchantID !== "") {
        const updateData = {
          id: this.state.id,
          merchantID: this.state.merchantID,
          firstName: this.state.firstName,
          lastName: this.state.lastName,
          dob: this.state.dob,
          phone: this.state.phone,
          address1: this.state.address1,
          address2: this.state.address2,
          addState: this.state.addState,
          addCity: this.state.addCity,
          cityID: this.state.cityID,
          city: this.state.city,
          state: this.state.state,
          country: this.state.countryValue,
          zipcode: this.state.zipcode,
          status: this.state.status,
          merchantName: this.state.merchantName,
          listMerchantDirectory: this.state.listMerchantDirectory,
          legalName: this.state.legalName,
          websiteUrl: this.state.websiteUrl,
          facebookPage: this.state.facebookPage,
          twitterPage: this.state.twitterPage,
          metaKeywords: this.state.metaKeywords,
          metaDesc: this.state.metaDesc,
          bankInfo: this.state.bankInfo,
          bankName: this.state.bankName,
          bankAccountNo: this.state.bankAccountNo,
          bankRoutingNum: this.state.bankRoutingNum,
          vatExempt: this.state.vatExempt,
          paymentTerms: this.state.paymentTerms,
          defaultTaxPerc: this.state.defaultTaxPerc,
          secondaryContactFirstName: this.state.secondaryContactFirstName,
          secondaryContactLastName: this.state.secondaryContactLastName,
          secondaryContactPhone: this.state.secondaryContactPhone,
          secondaryContactEmail: this.state.secondaryContactEmail,
          tertiaryContactFirstName: this.state.tertiaryContactFirstName,
          tertiaryContactLastName: this.state.tertiaryContactLastName,
          tertiaryContactPhone: this.state.tertiaryContactPhone,
          tertiaryContactEmail: this.state.tertiaryContactEmail,
          salesManagerID: this.state.salesManagerID,
          email: this.state.email,
        };

        this.props.dispatch(merchantActions.update_merchant(updateData));
      } else {
        const postData = {
          userName: this.state.userName,
          email: this.state.email,
          firstName: this.state.firstName,
          lastName: this.state.lastName,
          dob: this.state.dob,
          phone: this.state.phone,
          address1: this.state.address1,
          address2: this.state.address2,
          addState: this.state.addState,
          addCity: this.state.addCity,
          cityID: this.state.cityID,
          city: this.state.city,
          state: this.state.state,
          country: this.state.countryValue,
          zipcode: this.state.zipcode ? this.state.zipcode : "",
          status: this.state.status,
          merchantName: this.state.merchantName,
          listMerchantDirectory: this.state.listMerchantDirectory,
          legalName: this.state.legalName,
          websiteUrl: this.state.websiteUrl,
          facebookPage: this.state.facebookPage,
          twitterPage: this.state.twitterPage,
          metaKeywords: this.state.metaKeywords,
          metaDesc: this.state.metaDesc,
          bankInfo: this.state.bankInfo,
          bankName: this.state.bankName,
          bankAccountNo: this.state.bankAccountNo,
          bankRoutingNum: this.state.bankRoutingNum,
          vatExempt: this.state.vatExempt,
          paymentTerms: this.state.paymentTerms,
          defaultTaxPerc: this.state.defaultTaxPerc,
          secondaryContactFirstName: this.state.secondaryContactFirstName,
          secondaryContactLastName: this.state.secondaryContactLastName,
          secondaryContactPhone: this.state.secondaryContactPhone,
          secondaryContactEmail: this.state.secondaryContactEmail,
          tertiaryContactFirstName: this.state.tertiaryContactFirstName,
          tertiaryContactLastName: this.state.tertiaryContactLastName,
          tertiaryContactPhone: this.state.tertiaryContactPhone,
          tertiaryContactEmail: this.state.tertiaryContactEmail,
          salesManagerID: this.state.salesManagerID,
        };

        this.props.dispatch(merchantActions.add_merchant(postData));
      }
    }
    else{
    let arr = Object.values(yCoordinate)
    let min = Math.min(...arr);
    let yCoordinateKey= '',yCoordinateValue, xCoordinateValue
    {Object.keys(yCoordinate).map((key) => {
      if(yCoordinate[key] === min && yCoordinateKey.length == 0){
        yCoordinateValue = yCoordinate[key]
        yCoordinateKey = key
      }
    })}
    if(yCoordinateKey.length > 0){
      xCoordinateValue = xCoordinate[yCoordinateKey]
      window.scrollTo(xCoordinateValue,yCoordinateValue)
    }
    }
  }
  Clear() {
    (this.state.userName = ""),
      (this.state.email = ""),
      (this.state.id = ""),
      (this.state.merchantID = ""),
      (this.state.firstName = ""),
      (this.state.lastName = ""),
      (this.state.startDate = ""),
      (this.state.phone = ""),
      (this.state.address1 = ""),
      (this.state.address2 = ""),
      (this.state.cityID = ""),
      (this.state.city = ""),
      (this.state.state = ""),
      (this.state.countryValue = ""),
      (this.state.zipcode = ""),
      (this.state.status = "Active"),
      (this.state.merchantName = ""),
      (this.state.listMerchantDirectory = "0"),
      (this.state.legalName = ""),
      (this.state.websiteUrl = ""),
      (this.state.facebookPage = ""),
      (this.state.twitterPage = ""),
      (this.state.metaKeywords = ""),
      (this.state.metaDesc = ""),
      (this.state.bankInfo = 0),
      (this.state.bankName = ""),
      (this.state.bankAccountNo = ""),
      (this.state.bankRoutingNum = ""),
      (this.state.vatExempt = 1),
      (this.state.paymentTerms = "single-step"),
      (this.state.defaultTaxPerc = ""),
      (this.state.secondaryContactFirstName = ""),
      (this.state.secondaryContactLastName = ""),
      (this.state.secondaryContactPhone = ""),
      (this.state.secondaryContactEmail = ""),
      (this.state.tertiaryContactFirstName = ""),
      (this.state.tertiaryContactLastName = ""),
      (this.state.tertiaryContactPhone = ""),
      (this.state.tertiaryContactEmail = ""),
      (this.state.physicalLocations = []),
      (this.state.counter = 0),
      (this.state.changestateProps = false),
      (this.state.showBankInfo = false),
      (this.state.statesList = []),
      (this.state.citiesList = []),
      (this.state.FiltercitiesList = []),
      (this.state.changeCountry = false),
      (this.state.changeState = false),
      (this.state.changeCity = false),
      (this.state.updatingState = false),
      (this.state.show = false),
      (this.state.merchantclass = ""),
      (this.state.disabled = false),
      (this.state.salesManagerID = ""),
      (this.state.dob = "");
      phyidxx="";
  }

  handlePhysicalLocationsSubmit = merchantID => {
    let locAddress1 = [],
      locAddress2 = [],
      locPhone = [],
      locZipCode=[],
      taxPerc = [],
      locLatitude = [],
      locLongitude = [],
      loccityID = [],
      locCity = [],
      locState = [],
      locCountry = [],
      cityID = [],
      locID = [],
      LocationID = [],
      LocationName = [];

    let physicalLocations = this.state.physicalLocations;
    this.state.physicalLocations.map(
      phylocation => (
        locID.push(phylocation.locID),
        locAddress1.push(phylocation.locAddress1),
        locAddress2.push(phylocation.locAddress2),
        taxPerc.push(phylocation.taxPerc),
        locZipCode.push(phylocation.locZipCode),
        locPhone.push(phylocation.locPhone),
        locLatitude.push(phylocation.locLatitude),
        locLongitude.push(phylocation.locLongitude),
        loccityID.push(phylocation.loccityID),
        locCity.push(phylocation.locCity),
        locState.push(phylocation.locState),
        locCountry.push(phylocation.locCountry),
        cityID.push(phylocation.cityID),
        LocationID.push(phylocation.LocationID),
        LocationName.push(phylocation.LocationName)
      )
    );

    const postData = {
      locAddress1: locAddress1,
      locAddress2: locAddress2,
      locZipCode:locZipCode,
      locPhone: locPhone,
      taxPerc: taxPerc,
      locLatitude: locLatitude,
      locLongitude: locLongitude,
      cityID: loccityID,
      locCity: locCity,
      locState: locState,
      locCountry: locCountry,
      locID: locID,
      LocationID: LocationID,
      LocationName: LocationName,
    };
    this.props.dispatch(
      merchantActions.add_merchant_location(postData, merchantID)
    );
    phyidxx="";
  };

  onSelectedCountry = () => evt => {
    this.setState({ disabled: false });
    setTimeout((isLoading = "true"), 1000);
    const selectedCountry = this.state.countryData.find(
      k => k.country == evt.target.value
    );
    this.setState({
      changeCountry: true,
      countryValue: selectedCountry.country
    });
    this.props.dispatch(
      countryCityActions.getAllStatesData(selectedCountry.country)
    );
    if (this.state.countryValue.length === 0) {
      this.setState({ countryError: "" });
    }
    if(this.state.countryValue != selectedCountry.country){
      this.setState({stateName: '', Citytitle: ''});
    }
  };


  onSelectedCity = e => {
    const index = e.nativeEvent.target.selectedIndex;
    const selectedCityID = e.target.value
    const selectedCity = e.nativeEvent.target[index].text
    this.setState({
      city: selectedCity,
      cityID: selectedCityID,
    })
    if (selectedCityID) {
      this.setState({ cityIDError: '' })
    } else {
      this.setState({ cityIDError: 'red' })
    }
  }

  handleBankInfo = () => evt => {
    this.setState({ disabled: false });
    this.setState({ [evt.target.name]: evt.target.value });
    if (evt.target.value === "1") {
      this.setState({ showBankInfo: true });
    } else if (evt.target.value === "0") {
      this.setState({
        showBankInfo: false,
        bankName: "",
        bankAccountNo: "",
        bankRoutingNum: ""
      });
    }
  };

  handlesOnCountryChanged = idx => evt => {
    this.setState({ disabled: false });
    setTimeout((isLoading = "true"), 1000);
    const selectedCountry = this.state.countryData.find(
      k => k.country == evt.target.value
    );
    let phyLoc = this.state.physicalLocations;
    if(phyLoc[idx].locCountry !== selectedCountry.country){
      phyLoc[idx].locState = "";
      phyLoc[idx].loccityID = "";
      phyLoc[idx].locCity = "";
    }
    phyLoc[idx].locCountry = selectedCountry.country;
    this.setState({
      physicalLocations: phyLoc,
      counter: idx,
      changestateProps: true,
      updatingState: false
    });
    this.props.dispatch(
      countryCityActions.getAllStatesData(selectedCountry.country)
    );
    if (phyLoc[idx].locCountryError !== "") {
      phyLoc[idx].locCountryError = "";
      this.setState({ physicalLocations: phyLoc });
    }
  };

  handlesOnStateChanged = idx => evt => {
    this.setState({ disabled: false });
    setTimeout((isLoading = "true"), 1000);
    let phyLoc = this.state.physicalLocations;
    phyLoc[idx].locState = evt.target.value;
    this.setState({
      physicalLocations: phyLoc,
      counter: idx,
      changestateProps: true,
      updatingState: false
    });
    this.props.dispatch(countryCityActions.getAllCitiesData(evt.target.value));
    if (phyLoc[idx].locStateError !== "") {
      phyLoc[idx].locStateError = "";
      this.setState({ physicalLocations: phyLoc });
    }
  };

  handlesOnCityChanged = idx => evt => {
    this.setState({ disabled: false });
    const newPhysicalLocations = this.state.physicalLocations.map(
      (phylocation, pidx) => {
        if (idx !== pidx) return phylocation;
        return { ...phylocation, loccityID: evt.target.value, locCity: evt.target.value };
      }
    );

    this.setState({ physicalLocations: newPhysicalLocations });
    let phyLoc = this.state.physicalLocations;
    if (phyLoc[idx].locStateError !== "") {
      phyLoc[idx].locStateError = "";
      this.setState({ physicalLocations: phyLoc });
    }
  };

  handlesOnLocationIDChanged = idx => evt => {
    this.setState({ disabled: false });
    const newPhysicalLocations = this.state.physicalLocations.map(
      (phylocation, pidx) => {
        if (idx !== pidx) return phylocation;
        return { ...phylocation, LocationID: evt.target.value };
      }
    );

    this.setState({ physicalLocations: newPhysicalLocations });
    let phyLoc = this.state.physicalLocations;
    if (phyLoc[idx].LocationIDError !== "") {
      phyLoc[idx].LocationIDError = "";
      this.setState({ physicalLocations: phyLoc });
    }
  };

  handleUpdateCountryCity = physicalLoc => {
    this.setState({ disabled: false });
    const phyLocCountryStateCity = physicalLoc;
    physicalLoc.map((loc, index) => {
      this.props.dispatch(countryCityActions.getAllStatesData(loc.country));
      this.props.dispatch(countryCityActions.getAllCitiesData(loc.state));
    });
    this.setState({
      updatePhysicalLocCity: phyLocCountryStateCity,
      updatingState: true
    });
  };

  handleMappingOfCityValues = cities => {
    this.setState({ disabled: false });
    cities.map((city, index) => {
      this.state.updatePhysicalLocCity.map((loc, index) => {
        const selectedCity = city.find(k => k.cityID == loc.city);
        if (!isEmpty(selectedCity)) {
          let cityNames = this.state.citiesName;
          cityNames[loc.idx] = city;
          this.setState({ citiesName: cityNames });
        }
      });
    });
  };

  handleMappingOfStateValues = states => {
    this.setState({ disabled: false });
    states.map((state, index) => {
      this.state.updatePhysicalLocCity.map((loc, index) => {
        const selectedState = state.find(k => k.stateAbbr == loc.state);
        if (!isEmpty(selectedState)) {
          let stateNames = this.state.statesName;
          stateNames[loc.idx] = state;
          this.setState({ statesName: stateNames });
        }
      });
    });
  };

  // onChangeState = e => {
  //   this.setState({stateName: e.target.value, state:''});
  //   let FilterStateList = this.state.statesList;
  //   FilterStateList = FilterStateList.filter(
  //     item =>
  //       item.state.toLowerCase().search(e.target.value.toLowerCase()) !== -1
  //   );
  //   this.setState({FilterStateList: FilterStateList});
  //   let StateData = [];
  //   StateData = (this.state.statesList).filter(
  //     item =>
  //       item.state.toLowerCase() === e.target.value.toLowerCase()
  //   );
  //   if(StateData.length > 0) {
  //     this.setState({
  //       disabled: false, 
  //       changeState: true, 
  //       state: StateData[0].stateAbbr, 
  //       stateError:''
  //     });
  //     this.props.dispatch(countryCityActions.getAllCitiesData(StateData[0].stateAbbr)); 
  //   }
  // }

  onSelectedState = e => {
    const index = e.nativeEvent.target.selectedIndex;
    const selectedStateAbbr = e.target.value
    const selectedState = e.nativeEvent.target[index].text
    this.setState({
      state: selectedStateAbbr,
      selectedStateAbbr: selectedStateAbbr,
      addState: selectedState,
    })
    if (selectedStateAbbr) {
      this.setState({ stateError: '' })
    } else {
      this.setState({ stateError: 'red' })
    }
  }

  // onChangeCity = e => {
  //   this.setState({Citytitle: e.target.value, addCity: ''});
  //   let FiltercitiesList = this.state.citiesList;
  //   FiltercitiesList = FiltercitiesList.filter(
  //     item =>
  //       item.title.toLowerCase().search(e.target.value.toLowerCase()) !== -1
  //   )
  //   this.setState({FiltercitiesList: FiltercitiesList});
  //   let CityData = [];
  //   CityData = (this.state.citiesList).filter(
  //     item =>
  //       item.title.toLowerCase() === e.target.value.toLowerCase()
  //   );
  //   if(CityData.length > 0) {
  //     this.setState({
  //       disabled: false,
  //       changeCity: true,
  //       addCity: CityData[0].title,
  //       addCityError:''
  //     }); 
  //   }
  // }

  componentDidMount() {
    userinfo = auth.getUserInfo();
    this.handleDismiss();
    this.setState({ physicalLocations: [] });
    this.props.dispatch(alertsActions.clearAlerts());
    this.props.dispatch(salesPersonActions.getSalesManager());
    let userIdParams =
      this.props.match && this.props.match.params.userId
        ? this.props.match.params.userId
        : "";
    const editLink = this.props.match.params.userId && `addMerchant/${this.props.match.params.userId}`
    if (userIdParams && userIdParams !== "") {
      setTimeout((isLoading = "true"), 1000);
      this.props.dispatch(merchantActions.get_merchant(userIdParams));
      this.state.path = ["Home", "Manage Merchant", "Edit Merchant"];
      this.state.links = ["home", "merchantList", editLink];
    }

    let siteData = JSON.parse(localStorage.getItem('siteDDBStatus'))
    if (siteData.active_cities) {
      this.setState({
        cityList: siteData.active_cities,
        // stateList: siteData.active_states,
      })
    }

    const { dispatch } = this.props;
    dispatch(countryCityActions.getAllCountryData());
    this.setState({ countryData: this.props.countries });
    this.setState({
      country: this.props.country,
      countryName: this.props.countryName
    });
    if(this.props.country){
      this.props.dispatch(
        countryCityActions.getStateDataPhyLoc(this.props.country)
      );
    }
    this.props.dispatch(categoriesActions.getAllCategory());
    this.props.dispatch(merchantActions.get_merchant_type());
  }

  componentWillReceiveProps(nextProps) {
    let menuAclKey = this.state.menuKey;
    if(this.props.match && this.props.match.params.userId){
      menuAclKey = 'EDIT_MERCHANT';
    }
    if(!aclUtil.isPrimaryMenuAccessible(menuAclKey) && localStorage.getItem('userTypeName') !== 'merchant'){
      this.context.router.history.push("/restrictedAccess");
    }

    if (this.props.countries !== nextProps.countries) {
      this.setState({ countryData: nextProps.countries });
    }


    if (this.props.defaultTaxresponse !== nextProps.defaultTaxresponse && !isEmpty(nextProps.defaultTaxresponse)) {
      if(taxtype=="Primary"){
        this.setState({ defaultTaxPerc: nextProps.defaultTaxresponse.data });
      }
      else{
        let physicalLocations=this.state.physicalLocations;
        physicalLocations[phyidxx].taxPerc=nextProps.defaultTaxresponse.data;
        this.setState({ physicalLocations: physicalLocations });
      }  
    }

    if (this.props.coordinates !== nextProps.coordinates && !isEmpty(nextProps.coordinates)) {
      if(nextProps.coordinates){
        let physicalLocations=this.state.physicalLocations;
        physicalLocations[phyidxx].locLatitude=(nextProps.coordinates && nextProps.coordinates.data) ? nextProps.coordinates.data.latitude : "";
        physicalLocations[phyidxx].locLongitude=(nextProps.coordinates && nextProps.coordinates.data) ? nextProps.coordinates.data.longitude : "";
        isLoading = "false";
      }  
    }

    if (
      this.props.addMerchantResponse !== nextProps.addMerchantResponse &&
      !isEmpty(nextProps.addMerchantResponse)
    ) {
      const merchantID = (nextProps.addMerchantResponse.merchantID) ? nextProps.addMerchantResponse.merchantID : this.props.match.params.userId;
      this.handlePhysicalLocationsSubmit(merchantID);
      this.onSelectedCountry();
      window.scrollTo(0, 0);
    }

    if (
      this.props.mrechantResponse !== nextProps.mrechantResponse &&
      !isEmpty(nextProps.mrechantResponse)
    ) {
      this.props.dispatch(alertsActions.clearAlerts());
      this.props.dispatch(
        alertsActions.renderAlerts(
          "success",
          nextProps.mrechantResponse.message
        )
      );
      this.Clear();
      isLoading = "false";
      this.setState({ disabled: false });
      window.scrollTo(0, 0);
    }

    if (
      this.props.salesPersonList !== nextProps.salesPersonList &&
      !isEmpty(nextProps.salesPersonList)
    ) {
      this.setState({ salespersonlist: nextProps.salesPersonList.data.data });
    }

    if (
      this.props.updatedMerchant !== nextProps.updatedMerchant &&
      !isEmpty(nextProps.updatedMerchant)
    ) {
      this.handlePhysicalLocationsSubmit(merchantID);
      this.props.dispatch(alertsActions.clearAlerts());
      this.handleShow();
      this.props.dispatch(
        alertsActions.renderAlerts("success", nextProps.updatedMerchant.message)
      );
      isLoading = "false";
      this.setState({ disabled: false });
      this.props.dispatch(merchantActions.get_merchant(this.state.merchantID));
      window.scrollTo(0, 0);
    }

    if (
      this.props.states !== nextProps.states &&
      this.state.changestateProps &&
      !isEmpty(nextProps.states)
    ) {
      let stateArray = this.state.statesName;
      stateArray[this.state.counter] = nextProps.states;
      this.setState({ statesName: stateArray });
      isLoading = "false";
    }

    if (
      this.props.states !== nextProps.states &&
      this.state.changeCountry &&
      !isEmpty(nextProps.states)
    ) {
      let stateArray = this.state.statesList;
      stateArray = nextProps.states;
      this.setState({ stateList: stateArray, statesList: stateArray, FilterStateList:stateArray, changeCountry: false });
      isLoading = "false";
    }

    if (
      this.props.cityDetailsByState !== nextProps.cityDetailsByState &&
      this.state.changeState
    ) {
      let cityArray = this.state.citiesName;
      cityArray = nextProps.cityDetailsByState;
      this.setState({ citiesList: cityArray, FiltercitiesList: cityArray, changeState: false });
      isLoading = "false";
    }

    if (
      this.props.states !== nextProps.states &&
      this.state.updatingState &&
      this.state.updatePhysicalLocCity.length > 0 &&
      !isEmpty(nextProps.states)
    ) {
      let state = this.state.updateState;
      state.push(nextProps.states);
      this.setState({ updateState: state });
      this.handleMappingOfStateValues(state);
    }

    if (
      this.props.cityDetailsByState !== nextProps.cityDetailsByState &&
      this.state.updatingState &&
      this.state.updatePhysicalLocCity.length > 0 &&
      !isEmpty(nextProps.cityDetailsByState)
    ) {
      let city = this.state.updateCity;
      city.push(nextProps.cityDetailsByState);
      this.setState({ updateCity: city });
      this.handleMappingOfCityValues(city);
    }

    if (
      this.props.cityDetailsByState !== nextProps.cityDetailsByState &&
      this.state.changestateProps &&
      !isEmpty(nextProps.cityDetailsByState)
    ) {
      let cityArray = this.state.citiesName;
      cityArray[this.state.counter] = nextProps.cityDetailsByState;
      this.setState({ citiesName: cityArray });
      isLoading = "false";
    }

    if (this.props.error !== nextProps.error) {
      if (nextProps.error) {
        this.props.dispatch(alertsActions.clearAlerts());
        this.props.dispatch(
          alertsActions.renderAlerts("warning", nextProps.error)
        );
        isLoading = "false";
        window.scrollTo(0, 0);
      }
    }
    

    if(!isEmpty(nextProps.UploadLogo)) {
      if(nextProps.UploadLogo.response=="success")
      {
        this.setState({
          logomerchantId: '',
          showLogoPopup: false,
          isLoading: false,
          merchant_logo: nextProps.UploadLogo.data,
        });
      }
    }

    if (nextProps.message) {
      this.handleShow();
      this.setState({
        alertMessage: nextProps.message,
        msgType: nextProps.alertType
      });
    }
    if(!isEmpty(nextProps.merchantDetails)){
      let merchant = nextProps.merchantDetails;
      let tmpContactArray = [];
      if(merchant.secondaryContactFirstName && merchant.secondaryContactFirstName !='')
      {
        tmpContactArray.push(tmpContactArray.length);
        this.setState({ ContactInformation: tmpContactArray });
      }
      if(merchant.tertiaryContactFirstName && merchant.tertiaryContactFirstName !='')
      {
        tmpContactArray.push(tmpContactArray.length);
        this.setState({ ContactInformation: tmpContactArray });
      }
    }
    if (
      this.props.merchantDetails !== nextProps.merchantDetails &&
      !isEmpty(nextProps.merchantDetails)
    ) {
      if (nextProps.merchantDetails) {
        let merchant = nextProps.merchantDetails;
        if (merchant !== "") {
          isLoading = false;
        }
        this.props.dispatch(
          merchantActions.get_merchant_location(merchant.merchant_id)
        );
        merchantID = merchant.merchant_id;
        this.setState({
          id: merchant.user_id,
          merchantID: merchant.merchant_id,
          userName: merchant.userName,
          email: merchant.email,
          firstName: merchant.firstName,
          lastName: merchant.lastName,
          dob: (merchant.dob !== null) ? new Date(moment(merchant.dob).format('YYYY-MM-DD')) : "",
          phone: merchant.phone,
          address1: merchant.address1,
          address2: merchant.address2,
          addState: (merchant.addState != null) ? merchant.addState : "",
          addCity: (merchant.addCity != null) ? merchant.addCity : "",
          cityID: merchant.cityID,
          city: merchant.city,
          Citytitle: (merchant.addCity != null) ? merchant.addCity : "",
          stateName: (merchant.state_name != null) ? merchant.state_name : "",
          state: merchant.state,
          countryValue: merchant.country,
          zipcode: merchant.zipcode,
          status: merchant.status,
          merchantName: merchant.merchantName,
          listMerchantDirectory: merchant.listMerchantDirectory,
          legalName: merchant.legalName,
          websiteUrl: merchant.websiteUrl,
          facebookPage: merchant.facebookPage,
          twitterPage: merchant.twitterPage,
          metaKeywords: merchant.metaKeywords,
          metaDesc: merchant.metaDesc,
          bankInfo: merchant.bankInfo,
          bankName: merchant.bankName,
          bankAccountNo: merchant.bankAccountNo,
          bankRoutingNum: merchant.bankRoutingNum,
          vatExempt: merchant.vatExempt,
          paymentTerms: merchant.paymentTerms,
          defaultTaxPerc: merchant.defaultTaxPerc,
          secondaryContactFirstName: merchant.secondaryContactFirstName,
          secondaryContactLastName: merchant.secondaryContactLastName,
          secondaryContactPhone: merchant.secondaryContactPhone,
          secondaryContactEmail: merchant.secondaryContactEmail,
          tertiaryContactFirstName: merchant.tertiaryContactFirstName,
          tertiaryContactLastName: merchant.tertiaryContactLastName,
          tertiaryContactPhone: merchant.tertiaryContactPhone,
          tertiaryContactEmail: merchant.tertiaryContactEmail,
          changeState: true,
          changeCountry: true,
          salesManagerID: merchant.salesManagerID,
          menuKey: 'EDIT_MERCHANT',
          merchant_logo: merchant.merchant_logo,
        });
        

        this.props.dispatch(countryCityActions.getAllStatesData(merchant.country));
        this.props.dispatch(
          countryCityActions.getAllCitiesData(merchant.state)
        );
        if (merchant.bankInfo) {
          this.setState({ showBankInfo: true });
        } else {
          this.setState({ showBankInfo: false });
        }
      }
    }

    if (
      this.props.merchantLocationDetails !==
        nextProps.merchantLocationDetails &&
      !isEmpty(nextProps.merchantLocationDetails)
    ) {
      let editPhysicalLocation = [];
      let phyLocStateCity = [];
      let merchantlocationData = nextProps.merchantLocationDetails
        ? nextProps.merchantLocationDetails.data
        : [];
      if (merchantlocationData) {
        merchantlocationData.map((merchantLocation, index) => {
          editPhysicalLocation.push({
            locID: merchantLocation.locAddress1,
            locAddress1: merchantLocation.locAddress1,
            locAddress1Error: "",
            locAddress2: merchantLocation.locAddress2,
            locAddress2Error: "",
            locZipCode: merchantLocation.locZipCode,
            locZipCodeError: "",
            locPhone: merchantLocation.locPhone,
            locPhoneError: "",
            taxPerc: merchantLocation.taxPerc,
            taxPercError: "",
            locLatitude: merchantLocation.locLatitude,
            locLatitudeError: "",
            locLongitude: merchantLocation.locLongitude,
            locLongitudeError: "",
            locCity: merchantLocation.locCity,
            locCityError: "",
            locState: merchantLocation.locState,
            locStateError: "",
            locCountry: merchantLocation.locCountry,
            locCountryError: "",
            loccityID: merchantLocation.cityID,
            loccityIDError: "",
            locID: merchantLocation.locID,
            LocationID: merchantLocation.LocationID,
            LocationIDError : "",
            LocationName: merchantLocation.locationName,
            LocationNameError: "",
          });
          phyLocStateCity.push({
            country: merchantLocation.locCountry,
            state: merchantLocation.locState,
            city: merchantLocation.cityID,
            idx: index
          });
        });
      }

      this.setState({ physicalLocations: editPhysicalLocation });
      this.handleUpdateCountryCity(phyLocStateCity);
    }

    if (
      this.props.deletedLocationresponse !==
        nextProps.deletedLocationresponse &&
      !isEmpty(nextProps.deletedLocationresponse)
    ) {
      this.props.dispatch(
        merchantActions.get_merchant_location(this.state.merchantID)
      );
      this.props.dispatch(alertsActions.clearAlerts());
      this.handleShow();
      this.props.dispatch(
        alertsActions.renderAlerts(
          "success",
          nextProps.deletedLocationresponse.message
        )
      );
      window.scrollTo(0, 0);
    }
    if (
      this.props.deleteLocationError !== nextProps.deleteLocationError &&
      !isEmpty(nextProps.deleteLocationError)
    ) {
      this.props.dispatch(alertsActions.clearAlerts());
      this.handleShow();
      this.props.dispatch(
        alertsActions.renderAlerts("warning", nextProps.deleteLocationError)
      );
      window.scrollTo(0, 0);
    }
  }

  removeContact= ciKey => evt =>{
    let tmpArray = [...this.state.ContactInformation]; // make a separate copy of the array
    tmpArray.splice(ciKey, 1);
    if(ciKey == 0){
      this.setState({secondaryContactFirstName: '',
        secondaryContactLastName: '',
        secondaryContactPhone: '',
        secondaryContactEmail: ''})
    }
    if(ciKey == 1){
      this.setState({tertiaryContactFirstName: '',
        tertiaryContactLastName: '',
        tertiaryContactPhone: '',
        tertiaryContactEmail: ''})
    }
    this.setState({ContactInformation: tmpArray});
  }

  handleDefaultTax() {
    if(!isEmpty(this.state.state) && !isEmpty(this.state.zipcode)) {
      taxtype="Primary";
      const postData={
        stateAbbr: this.state.state,
        zipcode: this.state.zipcode
      }
      this.props.dispatch(
        merchantActions.get_default_tax(postData)
      );
    }
  }



  handlelocDefaultTax(idx) {
    const locZipCode =
      this.state.physicalLocations[idx] &&
      this.state.physicalLocations[idx].locZipCode;
    const locState =
      this.state.physicalLocations[idx] &&
      this.state.physicalLocations[idx].locState;
    if((locState) && (locZipCode)) {
      phyidxx=idx;
      taxtype="location";
      const postData={
        stateAbbr: locState,
        zipcode: locZipCode
      }
      this.props.dispatch(
        merchantActions.get_default_tax(postData)
      );
    }
  }

  handleLatLong(idx){
    isLoading = "true";
    const locZipCode =
      this.state.physicalLocations[idx] &&
      this.state.physicalLocations[idx].locZipCode;
    const locState =
      this.state.physicalLocations[idx] &&
      this.state.physicalLocations[idx].locState;
    const locCity =
      this.state.physicalLocations[idx] &&
      this.state.physicalLocations[idx].locCity;
    const locCountry =
      this.state.physicalLocations[idx] &&
      this.state.physicalLocations[idx].locCountry;
    const locAddress1 =
      this.state.physicalLocations[idx] &&
      this.state.physicalLocations[idx].locAddress1;
    const locAddress2 =
      this.state.physicalLocations[idx] &&
      this.state.physicalLocations[idx].locAddress2;
    if((locState) && (locZipCode)) {
      phyidxx=idx;
      taxtype="location";
      const postData={
        locAddress1: locAddress1,
        locAddress2 : locAddress2,
        locCity: locCity,
        locState: locState,
        locCountry: locCountry,
        locZipCode: locZipCode,
      }
      this.props.dispatch(
        merchantActions.get_lat_long(postData)
      );
    }
  }
    handleMerchantStatus = (key) => {
    if(key === 1){
      this.props.history.push('/addMerchant/'+this.state.merchantID)
    }else if(key === 2){
      this.props.history.push('/storeMerchant/'+this.state.merchantID)
    }else{
      this.props.history.push('/addMerchant'+'/'+this.state.merchantID)
    }
  }

  render() {
    
    const { errmsg } = this.props;
    let listMerchantDirectoryChecked = this.state.listMerchantDirectory == "1" ? "true" : "";
    let countrydata = this.state.countryData ? this.state.countryData : [];
    let phyidx = this.state.phylocidx;
    let countryItems, stateItems, cityItems, categoryItems, merchantTypeItems;
    if (countrydata) {
      countryItems = countrydata.map((countryObject, phyidx) => (
        <option key={countryObject.country} value={countryObject.country}>
          {countryObject.countryName}
        </option>
      ));
    }
    let salesManagerItems;
    let salespersonData = this.state.salespersonlist
      ? this.state.salespersonlist
      : "";
    if (salespersonData !== "") {
      salesManagerItems = salespersonData.map((salesObject, index) => (
        <option key={index} value={salesObject.user_id}>
          {salesObject.userName}
        </option>
      ));
    }

    return (
      <div className="col-lg-12 add-sub-admin">
        {this.props.error &&
        this.state.show &&
        this.state.alertMessage == "" ? (
          <div className="col-lg-12">
            <Alert
              bsStyle={this.props.error.msgType}
              onDismiss={this.handleDismiss}
            >
              <strong>{this.props.error.msgType}:</strong>{" "}
              {this.props.error.alertMessage}
            </Alert>
          </div>
        ) : isLoading == "true" ? (
          <div className="loader">
            <p className="loading-message">
              <i>Loading...</i>
            </p>
            <div className="spinner">
              <div className="dot1" />
              <div className="dot2" />
            </div>
          </div>
        ) : (
          ""
        )}
        <div>
          <form onSubmit={this.handleSubmit}>
            <div className="row">
              <div className="col-xs-12">
                <BreadcrumbComponent path={this.state.path} links={this.state.links} context={this.context}/>
              </div>
            </div>
            {/**start merchant information **/}
            
            <Tabs activeKey={this.state.key} onSelect={this.handleMerchantStatus} id="controlled-tab-example" >
              <Tab eventKey={1} title="Merchant Information">
            
            <div className="panel">
              <header className="panel-heading">Merchant Information </header>

              {this.state.show &&
                this.state.alertMessage !== "" && (
                  <div className="col-lg-12">
                    <Alert
                      bsStyle={this.state.msgType}
                      onDismiss={this.handleDismiss}
                    >
                      <strong>{this.state.msgType}:</strong>{" "}
                      {this.state.alertMessage}
                    </Alert>
                  </div>
                )}
              <div className="panel-body">
                <div className="add-city col-lg-12 col-md-12 col-sm-12 col-xs-12">
                  <Row>
                    <Col md={6} xs={12}>
                      <FormGroup controlId="formBasicMerchantNameText">
                        <ControlLabel>
                          <span style={{ color: "red" }}>*</span> Merchant Name
                        </ControlLabel>
                        <FormControl
                          type="text"
                          name="merchantName"
                          value={this.state.merchantName}
                          placeholder="Enter Merchant Name"
                          onChange={this.handleChange}
                          style={{ borderColor: this.state.merchantNameError }}
                        />
                      </FormGroup>
                      <FormGroup controlId="formBasicLegalNameText">
                        <ControlLabel>
                          <span style={{ color: "red" }}>*</span> Legal Name
                        </ControlLabel>
                        <FormControl
                          type="text"
                          value={this.state.legalName}
                          placeholder="Enter Legal Name"
                          onChange={this.handleChange}
                          name="legalName"
                          style={{ borderColor: this.state.legalNameError }}
                        />
                      </FormGroup>
                      <ControlLabel>
                        Website URL (Format: http://www.domainname.com)
                      </ControlLabel>
                      <FormGroup
                        controlId="formBasicWebsiteUrlText"
                        validationState={this.getValidationWebsiteUrlState()}
                      >
                        <FormControl
                          type="text"
                          value={this.state.websiteUrl}
                          placeholder="Enter Website URL"
                          onChange={this.handleChange}
                          name="websiteUrl"
                          onBlur={this.onWebsiteUrlBlur(this.state.websiteUrl)}
                        />
                        {this.state.websiteUrlError && (
                          <Tooltip
                            placement="bottom"
                            className="in"
                            id="tooltip-bottom"
                          >
                            {this.state.websiteUrlError}
                          </Tooltip>
                        )}
                      </FormGroup>
                      <FormGroup controlId="formBasicFacebookPageText">
                        <ControlLabel>Facebook Page</ControlLabel>
                        <FormControl
                          type="text"
                          value={this.state.facebookPage}
                          placeholder="Facebook Page"
                          onChange={this.handleChange}
                          name="facebookPage"
                        />
                        <p className="inline-validation-error">
                          {this.state.facebookPageError !== "" &&
                            this.state.facebookPageError}
                        </p>
                      </FormGroup>
                      <FormGroup controlId="formBasicTwitterPageText">
                        <ControlLabel>Twitter Page</ControlLabel>
                        <FormControl
                          type="text"
                          value={this.state.twitterPage}
                          placeholder="Twitter Page"
                          onChange={this.handleChange}
                          name="twitterPage"
                        />
                        <p className="inline-validation-error">
                          {this.state.twitterPageError !== "" &&
                            this.state.twitterPageError}
                        </p>
                        </FormGroup>
                      <FormGroup controlId="formBasicListMerchantDirectory">
                        <ControlLabel>List in Merchant Directory</ControlLabel>
                      </FormGroup>
                      <Checkbox
                        className="checkBox"
                        name="listMerchantDirectory"
                        checked={listMerchantDirectoryChecked}
                        value={this.state.listMerchantDirectory}
                        onChange={this.handleCheck}
                        inline
                      >
                        List in Merchant Directory
                      </Checkbox>
                      {this.state.showBankInfo && (
                        <div>
                          <FormGroup controlId="formBasicBankNameText">
                            <ControlLabel>Bank Name</ControlLabel>
                            <FormControl
                              type="text"
                              value={this.state.bankName}
                              placeholder="Bank Name"
                              onChange={this.handleChange}
                              name="bankName"
                            />
                            <p className="inline-validation-error" />
                          </FormGroup>
                          <FormGroup controlId="formBasicBankAccountNumberText">
                            <ControlLabel>Bank Account Number</ControlLabel>
                            <FormControl
                              type="text"
                              value={this.state.bankAccountNo}
                              placeholder="Bank Account Number"
                              onChange={this.handleChange}
                              name="bankAccountNo"
                            />
                            <p className="inline-validation-error" />
                          </FormGroup>
                        </div>
                      )}
                    </Col>
                    <Col md={6} xs={12}>
                      <FormGroup controlId="formBasicMetaKeywordsText">
                        <ControlLabel>Meta Keywords</ControlLabel>
                        <FormControl
                          type="text"
                          value={this.state.metaKeywords}
                          placeholder="Meta Keywords"
                          onChange={this.handleChange}
                          name="metaKeywords"
                        />
                        <p className="inline-validation-error">
                          {this.state.metaKeywordsError !== "" &&
                            this.state.metaKeywordsError}
                        </p>
                      </FormGroup>
                      <FormGroup controlId="formBasicMetaDescText">
                        <ControlLabel>Meta Description</ControlLabel>
                        <FormControl
                          type="text"
                          value={this.state.metaDesc}
                          placeholder="Meta Description"
                          onChange={this.handleChange}
                          name="metaDesc"
                        />
                        <p className="inline-validation-error">
                          {this.state.metaDescError !== "" &&
                            this.state.metaDescError}
                        </p>
                      </FormGroup>
                      <FormGroup controlId="formControlsVatExempt">
                        <ControlLabel>Tax Exempt?</ControlLabel>
                        <FormControl
                          componentClass="select"
                          placeholder="Tax Exempt"
                          name="vatExempt"
                          value={this.state.vatExempt}
                          onChange={this.handleChange}
                        >
                          <option value="1"> Yes </option>
                          <option value="0">No</option>
                        </FormControl>
                        <p className="inline-validation-error">
                          {this.state.vatExemptError !== "" &&
                            this.state.vatExemptError}
                        </p>
                      </FormGroup>
                      <FormGroup controlId="formControlsPaymentTerms">
                        <ControlLabel>Payment Terms?</ControlLabel>
                        <FormControl
                          componentClass="select"
                          placeholder="Payment Terms"
                          name="paymentTerms"
                          value={this.state.paymentTerms}
                          onChange={this.handleChange}
                        >
                          <option value="single-step">Single Step</option>
                          <option value="multiple-step"> Multi Step </option>
                        </FormControl>
                        <p className="inline-validation-error">
                          {this.state.paymentTermsError !== "" &&
                            this.state.paymentTermsError}
                        </p>
                      </FormGroup>

                      <FormGroup controlId="formControlsBankInformation">
                        <ControlLabel>Bank Information?</ControlLabel>
                        <FormControl
                          componentClass="select"
                          placeholder="Merchant Type"
                          name="bankInfo"
                          value={this.state.bankInfo}
                          onChange={this.handleBankInfo()}
                        >
                          <option value="0">No</option>
                          <option value="1"> Yes </option>
                        </FormControl>
                        <p className="inline-validation-error">
                          {this.state.bankInfoError !== "" &&
                            this.state.bankInfoError}
                        </p>
                      </FormGroup>
                      {this.state.showBankInfo && (
                        <div>
                          <FormGroup controlId="formBasicBankRoutingNumText">
                            <ControlLabel>Bank Routing Number</ControlLabel>
                            <FormControl
                              type="text"
                              value={this.state.bankRoutingNum}
                              placeholder="Bank Routing Number"
                              onChange={this.handleChange}
                              name="bankRoutingNum"
                            />
                            <p className="inline-validation-error" />
                          </FormGroup>
                        </div>
                      )}
                    </Col>
                  </Row>
                  
                </div>
              </div>
            </div>
            {this.state.merchantID ? ( 
              <div className="panel">
                <header className="panel-heading">Merchant Logo </header>
                <div className="panel-body">
                  <div className="add-city col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <Row>
                      <Col md={4} xs={4}>
                      <Image src={this.state.merchant_logo} className="responsive" />
                      </Col>
                      <Col md={12} xs={12}>
                        <Button
                          type="button"
                          bsStyle="info"
                          onClick={this.handleAddLogo}
                          className="small"
                          data-key={this.state.merchantID}
                        >
                          Upload Logo
                        </Button>
                      </Col>
                    </Row>
                  </div>
                </div>
              </div> 
              )
              : (
               ""
              )
            }
            {/**end merchant information **/}
            {/**start primary contact information**/}
            <div className="panel">
              <header className="panel-heading">
                Primary Contact Information
              </header>
              <div className="panel-body">
                <div className="add-city col-lg-12 col-md-12 col-sm-12 col-xs-12">
                  <Row>
                    <Col md={4} xs={12}>
                      <FormGroup controlId="formBasicUserNameText">
                        <ControlLabel>
                         User Name
                        </ControlLabel>
                        <FormControl
                          type="text"
                          name="userName"
                          value={this.state.userName}
                          placeholder="Enter User Name"
                          onChange={this.handleChange}
                          readOnly={this.state.merchantID ? true : false}
                        />
                      </FormGroup>
                      <FormGroup controlId="formBasicFirstNameText">
                        <ControlLabel>
                          First Name
                        </ControlLabel>
                        <FormControl
                          type="text"
                          value={this.state.firstName}
                          placeholder="Enter First Name"
                          onChange={this.handleChange}
                          name="firstName"
                        />
                      </FormGroup>
                      <FormGroup controlId="formBasicLastNameText">
                        <ControlLabel>
                          Last Name
                        </ControlLabel>
                        <FormControl
                          type="text"
                          value={this.state.lastName}
                          placeholder="Enter Last Name"
                          onChange={this.handleChange}
                          name="lastName"
                        />
                      </FormGroup>
                    </Col>
                    <Col md={4} xs={12}>
                      <ControlLabel>
                        <span style={{ color: "red" }}>*</span> Email
                      </ControlLabel>
                      <FormGroup
                        controlId="formBasicEmailText"
                        validationState={this.getValidationEmailState()}
                      >
                        <FormControl
                          type="email"
                          value={this.state.email}
                          placeholder="Enter email"
                          onChange={this.handleChange}
                          name="email"
                          style={{ borderColor: this.state.emailError }}
                          readOnly={false}
                        />
                      </FormGroup>
                      <ControlLabel>Phone (format: xxx-xxx-xxxx)</ControlLabel>
                      <FormGroup
                        controlId="formBasicPhoneText"
                        validationState={this.getValidationState()}
                      >
                        <NumberFormat
                        format="###-###-####"
                        mask="_"
                        className="form-control"
                        name="phone"
                        placeholder="Enter Phone Number"
                        value={this.state.phone}
                        onChange={this.handleChange}
                      />
                      </FormGroup>
                      
                      <FormGroup controlId="formControlsStatusSelect">
                        <ControlLabel>Status</ControlLabel>
                        <FormControl
                          componentClass="select"
                          placeholder="select"
                          name="status"
                          value={this.state.status}
                          onChange={this.handleChange}
                        >
                          <option value="Active">Active</option>
                          <option value="Inactive"> Inactive </option>
                        </FormControl>
                        <p className="inline-validation-error" />
                      </FormGroup>
                    </Col>
                    <Col md={4} xs={12}>
                      <FormGroup controlId="formExpirationDate">
                        <ControlLabel>Date Of Birth</ControlLabel><br/>
                        <DatePicker
                          onChange={this.onChangeStartDate}
                          value={(this.state.dob) ? this.state.dob : ""}
                        />
                        <p className="inline-validation-error">
                          {this.state.dobError !== "" && this.state.dobError}
                        </p>
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <HorizontalLine />
                    <Col md={6} xs={12}>
                      <FormGroup controlId="formBasicAddressOneText">
                        <ControlLabel>
                          Address 1
                        </ControlLabel>
                        <FormControl
                          type="text"
                          value={this.state.address1}
                          placeholder="Enter Address"
                          onChange={this.handleChange}
                          name="address1"
                        />
                      </FormGroup>
                      <FormGroup controlId="formBasicAddressTwoText">
                        <ControlLabel>Address 2</ControlLabel>
                        <FormControl
                          type="text"
                          value={this.state.address2}
                          placeholder="Enter Address"
                          onChange={this.handleChange}
                          name="address2"
                        />
                        <p className="inline-validation-error">
                          {this.state.address2Error !== "" &&
                            this.state.address2Error}
                        </p>
                      </FormGroup>
                     
                      <div className="city autocompleted">
                        {isLoading == "true" ? (
                          <div className="loader">
                            <p className="loading-message">
                              <i>Loading...</i>
                            </p>
                            <div className="spinner">
                              <div className="dot1" />
                              <div className="dot2" />
                            </div>
                          </div>
                        ) : (
                          ""
                        )}
                        <div className="form-group" id="primaryContactInfoCountry">
                          <label htmlFor="country">
                            <span style={{ color: "red" }}>*</span> Country
                          </label>
                          <select
                            name="Country"
                            className="form-control"
                            style={{ borderColor: this.state.countryError }}
                            value={this.state.countryValue}
                            onChange={this.onSelectedCountry()}
                            
                          >
                            <option key="select default">
                              Select a country
                            </option>
                            {countryItems}
                          </select>
                        </div>
                        <div className="form-group " id="primaryContactInfoState">
                          <label htmlFor="state">
                            <span style={{ color: "red" }}>*</span> State
                          </label>
                          <FormControl
                            componentClass="select"
                            value={this.state.state}
                            name="state"
                            onChange={this.onSelectedState}
                            style={{
                              borderColor: this.state.stateError,
                            }}
                          >
                            <option value="">Choose State</option>
                            {this.state.stateList &&
                              this.state.stateList.map((states, index) => (
                              <option key={index} value={states.stateAbbr}>
                                {states.state}
                              </option>
                            ))}
                          </FormControl>
                        </div>
                      </div>
                      
                    </Col>
                    <Col md={6} xs={12} >
                      <FormGroup controlId="formBasicAddCityText">
                        <ControlLabel><span style={{ color: 'red' }}>*</span>City</ControlLabel>
                        <FormControl
                          type="text"
                          value={this.state.addCity}
                          placeholder="Enter City"
                          onChange={this.handleChange}
                          style={{ borderColor: this.state.addCityError }}
                          name="addCity"
                        />
                      </FormGroup>
                      <FormGroup controlId="formBasicZipText">
                        <ControlLabel>Zip Code</ControlLabel>
                        <FormControl
                          type="text"
                          value={this.state.zipcode}
                          placeholder="Enter Zipcode"
                          onChange={this.handleChange}
                          name="zipcode"
                        />
                        <p className="inline-validation-error">
                          {this.state.zipcodeError !== "" &&
                            this.state.zipcodeError}
                        </p>
                      </FormGroup>
                      
                        <FormGroup controlId="formBasicDefaultTaxPercText">
                        <ControlLabel>Default Tax %</ControlLabel>
                        <FormControl
                          type="text"
                          value={this.state.defaultTaxPerc}
                          placeholder="Default Tax %"
                          onChange={this.handleChange}
                          name="defaultTaxPerc"
                          readOnly={true}
                        />
                        
                       
                      </FormGroup>
                      <Button
                          bsStyle="info"
                          type="button"
                          onClick={this.handleDefaultTax.bind(this)}
                      >
                        Get State Tax
                      </Button>
                    </Col>
                  </Row>
                </div>
              </div>
            </div>
            {/**end primary contact information**/}
            {/**start secondary contact information**/}

            <div className="panel">
              <header className="panel-heading">
                More Contact Information
              </header>
              <div className="panel-body">
                <div className="add-city col-lg-12 col-md-12 col-sm-12 col-xs-12">
                  {this.state.ContactInformation.map(contactIndex => (
                    <Row key={'CI'+contactIndex}>
                      <Col md={3} xs={12}>
                        <FormGroup controlId={'formBasic'+ContactInformationArr[contactIndex].ciName+'FirstNameText'}>
                          <ControlLabel>First Name</ControlLabel>
                          <FormControl
                            type="text"
                            value={this.state[ContactInformationArr[contactIndex].ciKey+'ContactFirstName']}
                            placeholder="Enter First Name"
                            onChange={this.handleChange}
                            name={ContactInformationArr[contactIndex].ciKey+'ContactFirstName'}
                          />
                        </FormGroup>
                      </Col>
                      <Col md={3} xs={12}>
                        <FormGroup controlId={'formBasic'+ContactInformationArr[contactIndex].ciName+'LastNameText'}>
                          <ControlLabel>Last Name</ControlLabel>
                          <FormControl
                            type="text"
                            value={this.state[ContactInformationArr[contactIndex].ciKey+'ContactLastName']}
                            placeholder="Enter Last Name"
                            onChange={this.handleChange}
                            name={ContactInformationArr[contactIndex].ciKey+'ContactLastName'}
                          />
                        </FormGroup>
                      </Col>
                      <Col md={3} xs={12}>
                        <ControlLabel>Email</ControlLabel>
                        <FormGroup
                          controlId={'formBasic'+ContactInformationArr[contactIndex].ciName+'EmailText'}
                          validationState={this.getValidationSecondryEmailState()}
                        >
                          <FormControl
                            type="email"
                            defaultValue={this.state[ContactInformationArr[contactIndex].ciKey+'ContactEmail']}
                            placeholder="Enter email"
                            onBlur={this.handleChange}
                            name={ContactInformationArr[contactIndex].ciKey+'ContactEmail'}
                            required
                            disabled={(this.state.merchantID && (this.state[ContactInformationArr[contactIndex].ciKey+'ContactEmail'] !== null && this.state[ContactInformationArr[contactIndex].ciKey+'ContactEmail'] !== '')) ? true : false}
                          />
                        </FormGroup>
                      </Col>
                      <Col md={3} xs={12}>
                        <ControlLabel>Phone (format: xxx-xxx-xxxx)</ControlLabel>
                        <FormGroup
                          controlId={'formBasic'+ContactInformationArr[contactIndex].ciName+'PhoneText'}
                          validationState={this.getValidationsecondaryContactState()}
                        >
                          <NumberFormat
                            format="###-###-####"
                            mask="_"
                            className="form-control"
                            name={ContactInformationArr[contactIndex].ciKey+'ContactPhone'}
                            placeholder="Enter Phone Number"
                            value={this.state[ContactInformationArr[contactIndex].ciKey+'ContactPhone']}
                            onChange={this.handleChange}
                          />
                          {this.state.ContactInformation.length == contactIndex+1 ? (
                          <a onClick={this.removeContact(contactIndex)}><i className="glyphicon glyphicon-trash" aria-hidden="true"></i></a>
                          ) : ("")}
                        </FormGroup>

                      </Col>
                    </Row>
                  ))}

                  {(this.state.ContactInformation.length < 2) ? (
                      <Row>
                      <Col md={12} xs={12}>
                        <Button
                          type="button"
                          bsStyle="info"
                          onClick={this.handleAddContactLocation}
                          className="small"
                        >
                          Add Contact
                        </Button>
                      </Col>
                    </Row>
                  ) : ("")
                }
                </div>
              </div>
            </div>
            {/**start physical location**/}
            <div className="panel">
              <header className="panel-heading">Physical Locations</header>
              <div className="panel-body">
                <div className="add-city col-lg-12 col-md-12 col-sm-12 col-xs-12">
                  {this.state.physicalLocations.map((phylocation, idx) => (
                    <Row className="phylocation" key={idx}>
                      <Col md={6} xs={12}>
                        <FormGroup controlId={`formBasicLocationNameText${idx}`}>
                          <ControlLabel>
                            Location Name
                          </ControlLabel>
                          <FormControl
                            key={idx}
                            type="text"
                            value={phylocation.LocationName}
                            placeholder={`Location Name`}
                            onChange={this.handleLocationName(idx)}
                            name={`LocationName${idx}`}
                            //style={{borderColor:phylocation.locAddress1Error}}
                          />
                          <p className="inline-validation-error">
                            {phylocation.LocationNameError.length > 0 &&
                              phylocation.LocationNameError}
                          </p>
                        </FormGroup>
                        <ControlLabel>
                          Address 1 (Street number and name here only){" "}
                        </ControlLabel>
                        <FormGroup
                          controlId={`formBasicLocAddress1Text${idx}`}
                          validationState={this.getValidationPhysicalLocationAddress1State(
                            idx
                          )}
                        >
                          <FormControl
                            key={idx}
                            type="text"
                            value={phylocation.locAddress1}
                            placeholder={`Address 1`}
                            onChange={this.handleLocAddress1Change(idx)}
                            name={`locAddress1${idx}`}
                            //style={{borderColor:phylocation.locAddress1Error}}
                          />
                        </FormGroup>
                        <FormGroup controlId={`formBasicLocAddress2Text${idx}`}>
                          <ControlLabel>
                            Address 2 (Suite numbers or address notes go here)
                          </ControlLabel>
                          <FormControl
                            key={idx}
                            type="text"
                            value={phylocation.locAddress2}
                            placeholder={`Address 2`}
                            onChange={this.handleLocAddress2Change(idx)}
                            name={`locAddress2${idx}`}
                          />
                          <p className="inline-validation-error">
                            {phylocation.locAddress2Error.length > 0 &&
                              phylocation.locAddress2Error}
                          </p>
                        </FormGroup>

                        <div className="city">
                          <div className="form-group" phyloc={`phyloca${idx}`}>
                            <label htmlFor={`locCountry${idx}`}>Country</label>
                            <select
                              key={idx}
                              name={`locCountry${idx}`}
                              className="form-control"
                              value={
                                this.state.physicalLocations[idx].locCountry
                              }
                              onChange={this.handlesOnCountryChanged(idx)}
                            >
                              <option key="select default">
                                Select a country
                              </option>
                              {countryItems}
                            </select>
                            <p className="inline-validation-error">
                              {phylocation.locCountryError.length > 0 &&
                                phylocation.locCountryError}
                            </p>
                          </div>
                          <div className="form-group" phyloc={`phystate${idx}`}>
                            <label htmlFor={`locState${idx}`}>State</label>
                            <select
                              key={idx}
                              name={`locState${idx}`}
                              className="form-control"
                              value={this.state.physicalLocations[idx].locState}
                              onChange={this.handlesOnStateChanged(idx)}
                            >
                              <option>Select a state</option>
                              {this.state.statesName[idx] &&
                                this.state.statesName[idx].length > 0 &&
                                this.state.statesName[idx].map(
                                  (stateObject, phyidx) => (
                                    <option
                                      key={stateObject.stateAbbr}
                                      value={stateObject.stateAbbr}
                                    >
                                      {stateObject.state}
                                    </option>
                                  )
                                )}
                            </select>
                            <p className="inline-validation-error">
                              {phylocation.locStateError.length > 0 &&
                                phylocation.locStateError}
                            </p>
                          </div>
                          <div className="form-group" phyloc={`phycity${idx}`}>
                            <label htmlFor={`locCity${idx}`}>City</label>
                            <FormControl
                              key={idx}
                              type="text"
                              placeholder={`City`}
                              value={
                                this.state.physicalLocations[idx].locCity
                              }
                              autoComplete="off"
                              onChange={this.handlesOnCityChanged(idx)}
                              name={`locCity${idx}`}
                            />
                            <p className="inline-validation-error">
                              {phylocation.loccityIDError.length > 0 &&
                                phylocation.loccityIDError}
                            </p>
                          </div> 
                        </div> 
                      </Col>
                      <Col md={6} xs={12}>
                        <ControlLabel>
                          Zipcode
                        </ControlLabel>
                        <FormGroup
                          controlId={`formBasiclocZipCodeText${idx}`}
                          
                        >
                           <FormControl
                            key={idx}
                            type="text"
                            value={phylocation.locZipCode}
                            placeholder={`Zipcode`}
                            onChange={this.handlelocZipCodeChange(idx)}
                            name={`locZipCode${idx}`}
                          />
                        </FormGroup>       

                        <ControlLabel>
                          Phone (format: xxx-xxx-xxxx)
                        </ControlLabel>
                        <FormGroup
                          controlId={`formBasiclocPhoneText${idx}`}
                          validationState={this.getValidationLocPhone(idx)}
                        >
                          <NumberFormat
                            format="###-###-####"
                            key={idx}
                            mask="_"
                            className="form-control"
                            name={`locPhone${idx}`}
                            placeholder={`Phone`}
                            value={phylocation.locPhone}
                            onChange={this.handlelocPhoneChange(idx)}
                          />
                        </FormGroup>
                      
                        <ControlLabel>
                          Latitude (format: 0.1 Or -0.1)
                        </ControlLabel>
                        <FormGroup
                          controlId={`formBasiclocLatitudeText${idx}`}
                        >
                          <FormControl
                            key={idx}
                            type="text"
                            value={phylocation.locLatitude}
                            placeholder={`Latitude`}
                            onChange={this.handleLocLatitudeChange(idx)}
                            onBlur={this.handleBlurLatitude(idx)}
                            name={`locLatitude${idx}`}
                          />
                          {phylocation.locLatitudeError.length > 0 && (
                            <Tooltip
                              placement="bottom"
                              className="in"
                              id="tooltip-bottom"
                            >
                              {phylocation.locLatitudeError}
                            </Tooltip>
                          )}
                        </FormGroup>
                        <ControlLabel>
                          Longitude (format: 0.1 Or -0.1)
                        </ControlLabel>
                        <FormGroup
                          controlId={`formBasiclocLongitudeText${idx}`}
                        >
                          <FormControl
                            key={idx}
                            type="text"
                            value={phylocation.locLongitude}
                            placeholder={`Longitude`}
                            onChange={this.handleLocLongitudeChange(idx)}
                            name={`locLongitude${idx}`}
                            onBlur={this.handleBlurLongitude(idx)}
                          />
                          {phylocation.locLongitudeError.length > 0 && (
                            <Tooltip
                              placement="bottom"
                              className="in"
                              id="tooltip-bottom"
                            >
                              {phylocation.locLongitudeError}
                            </Tooltip>
                          )}
                        </FormGroup>

                        <FormGroup controlId={`formBasicLocationID${idx}`}>
                          <ControlLabel>
                            Location ID
                          </ControlLabel>
                          <FormControl
                            key={idx}
                            type="text"
                            value={phylocation.LocationID}
                            placeholder={`Location ID`}
                            onChange={this.handlesOnLocationIDChanged(idx)}
                            name={`LocationID${idx}`}
                          />
                          <p className="inline-validation-error"> 
                          </p>
                        </FormGroup>

                        <FormGroup controlId={`formBasictaxPercText${idx}`}>
                          <ControlLabel>Tax %</ControlLabel>
                          <FormControl
                            key={idx}
                            type="text"
                            value={phylocation.taxPerc}
                            placeholder={`Tax %`}
                            onChange={this.handletaxPercChange(idx)}
                            name={`taxPerc${idx}`}
                            readOnly={true}
                          />
                          
                        </FormGroup>
                        <Button
                            bsStyle="info"
                            type="button"
                            onClick={this.handlelocDefaultTax.bind(this,idx)}
                        >
                          Get State Tax
                        </Button>
                        <Button
                            bsStyle="info"
                            type="button"
                            onClick={this.handleLatLong.bind(this, idx)}
                        >
                          Get Latitude & Longitude
                        </Button>

                      </Col>
                      <Col md={12} xs={12}>
                        <Button
                          type="button"
                          bsStyle="danger"
                          onClick={this.handleRemovePhysicalLocation(idx)}
                          className="small"
                        >
                          Remove
                        </Button>
                        <HorizontalLine />
                      </Col>
                    </Row>
                  ))}
                  <Row>
                    <Col md={12} xs={12}>
                      <Button
                        type="button"
                        bsStyle="info"
                        onClick={this.handleAddPhysicalLocation}
                        className="small"
                      >
                        Add Physical Location
                      </Button>
                    </Col>
                  </Row>
                </div>
              </div>
            </div>
            {/**end physical location**/}
            {userinfo.userTypeName !== "salesmanager" ? (
              <div className="panel">
                <header className="panel-heading">Administrative Option</header>
                <div className="panel-body">
                  <div className="add-city col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <Row>
                      <Col md={3} xs={12}>
                        <FormGroup controlId="formBasicCityIDText">
                          <ControlLabel >
                            <span style={{ color: 'red' }}>*</span> City:
                          </ControlLabel>
                          <FormControl
                            componentClass="select"
                            value={this.state.cityID}
                            name="cityID"
                            onChange={this.onSelectedCity}
                            style={{
                              borderColor: this.state.cityIDError,
                            }}
                          >
                            <option value="">Choose Region/City</option>
                            {this.state.cityList &&
                              this.state.cityList.map((data, i) => (
                                <optgroup key={i} label={data.country}>
                                  {data.cities &&
                                    data.cities.map((city, index) => (
                                      <option key={index} value={city.cityID}>
                                        {city.title}
                                      </option>
                                    ))}
                                </optgroup>
                              ))}
                          </FormControl>
                        </FormGroup>
                      </Col>
                      <Col md={3} xs={12}>
                        <FormGroup controlId="formControlsSelectPerson">
                          <ControlLabel> Sales Person</ControlLabel>
                          <FormControl
                            componentClass="select"
                            name="salesManagerID"
                            value={this.state.salesManagerID}
                            onChange={this.handleChange}
                          >
                            <option>Select Sales Person</option>
                            {salesManagerItems}
                          </FormControl>
                        </FormGroup>
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            ) : (
              ""
            )}

            <Row className="BtnRow">
              <Col md={12} xs={12}>
                <Button
                  bsStyle="info"
                  type="submit"
                  disabled={this.state.disabled}
                >
                  Save
                </Button>
                <Button
                  bsStyle="default"
                  onClick={() => (localStorage.getItem('userTypeName') == 'merchant') ? this.context.router.history.push(`/dashboard`) : this.context.router.history.push(`/merchantList`)}
                >
                  Cancel
                </Button>
              </Col>
            </Row>
            </Tab>
            {(this.state.merchantID != '') ?
            <Tab eventKey={2} title="Storefront Design">
            </Tab>
            : 
            ''
            }
           </Tabs>
          </form>
        </div>

        <Modal show={this.state.showLogoPopup} onHide={this.LogoClosePopup}>
          <Modal.Header closeButton>
            <Modal.Title>Upload Logo</Modal.Title>
          </Modal.Header>
          <Modal.Body>
             <FormGroup>
                  <ControlLabel>Upload Merchant Logo</ControlLabel>
                  <FormControl
                    type="file"
                    id="file"
                    onChange={this.handleLogoData}
                  />
            </FormGroup>
          </Modal.Body>
          <Modal.Footer>
            <Button bsStyle="success" onClick={this.UploadLogo} disabled={this.state.isLoading===true ? true : false}>Upload</Button>
            <Button bsStyle="danger" onClick={this.LogoClosePopup}>Close</Button>
          </Modal.Footer>
        </Modal>

      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    countries: state.countryCityReducers.countries,
    states: state.countryCityReducers.states,
    cityDetailsByState: state.countryCityReducers.cityDetailsByState,
    addMerchantResponse: state.merchantReducer.addMerchantResponse,
    merchantDetails: state.merchantReducer.merchantDetails,
    merchantLocationDetails: state.merchantReducer.merchantLocationDetails,
    error: state.merchantReducer.error,
    countryError: state.countryCityReducers.error,
    categoryError: state.categoryReducer.error,
    sendingMerchant: state.merchantReducer.sendingMerchant,
    deletedLocationresponse: state.merchantReducer.deletedLocationresponse,
    requestingDeleteLocation: state.merchantReducer.requestingDeleteLocation,
    deleteLocationError: state.merchantReducer.deleteLocationError,
    errmsg: state.merchantReducer.errmsg,
    alertType: state.alertsReducer.alertType,
    message: state.alertsReducer.message,
    mrechantResponse: state.merchantReducer.mrechantResponse,
    updatedMerchant: state.merchantReducer.updatedMerchant,
    salesPersonList: state.salesPersonReducer.salesPersonList,
    defaultTaxresponse:state.merchantReducer.defaultTaxresponse,
    coordinates:state.merchantReducer.coordinates,
    UploadLogo:state.merchantReducer.LogoDetail
  };
};

export default compose(
  withRouter, // IMPORTANT: witRouter is "needed here" to avoid blocking routing:
  connect(mapStateToProps)
)(AddMerchant);



// WEBPACK FOOTER //
// ./src/app/views/admin/merchant/AddMerchant.js